// src/pages/CourseTime/utils/positionUtils.js

// Position tracking effect - runs every 5 seconds for normal navigation
export const setupPositionTracking = (
  activeSessionNo,
  activeSegment,
  currentSlideIndex,
  profileId,
  identifier,
  sessionContent,
  updateCurrentPosition,
  positionUpdateIntervalRef,
  lastPositionUpdateRef
) => {
  if (activeSessionNo && activeSegment && currentSlideIndex >= 0 && profileId && identifier) {
    // Clear existing interval
    if (positionUpdateIntervalRef.current) {
      clearInterval(positionUpdateIntervalRef.current);
    }
    
    // Set up new interval for throttled position updates
    positionUpdateIntervalRef.current = setInterval(() => {
      const currentPosition = {
        session: activeSessionNo,
        segment: activeSegment,
        slide: currentSlideIndex
      };
      
      // Only update if position has changed and it's not a critical moment
      const lastUpdate = lastPositionUpdateRef.current;
      if (!lastUpdate || 
          lastUpdate.session !== currentPosition.session ||
          lastUpdate.segment !== currentPosition.segment ||
          lastUpdate.slide !== currentPosition.slide) {
        
        // Don't use throttled update for last slides (they trigger immediate updates)
        const segmentSlides = sessionContent?.[activeSegment] || [];
        const isLastSlideOfSegment = currentSlideIndex === segmentSlides.length - 1;
        
        if (!isLastSlideOfSegment) {
          updateCurrentPosition(currentPosition.session, currentPosition.segment, currentPosition.slide, false);
        }
      }
    }, 5000); // Update every 5 seconds
  }
  
  return () => {
    if (positionUpdateIntervalRef.current) {
      clearInterval(positionUpdateIntervalRef.current);
    }
  };
};
